import React, { useCallback, useContext, useRef } from 'react'
import get from 'lodash/get'

interface IProps {
  text: string
  submitClick: (content: string) => void
}

function Input({ text, submitClick }: IProps) {
  const inputRef = useRef(null)
  return (
    <div className="focus-input">
      <div className="input">
        <textarea
          autoFocus
          ref={inputRef}
          rows={4}
          placeholder="写下您的评论..."
        />
      </div>
      <div
        className="submit"
        onClick={() => {
          const content = get(inputRef, 'current.value')
          submitClick(content)
        }}
      >
        {text}
      </div>
      <style jsx>
        {`
          .focus-input {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            background-color: #f7f8fc;
            border: solid 1px #1f2129;
            width: 100%;
            height: 144px;
            border-radius: 2px;
          }
          .focus-input .input {
            padding: 10px 20px;
            width: 100%;
            background-color: white;
            height: 96px;
          }
          .focus-input .input textarea {
            width: 100%;
            height: 100%;
            resize: none;
            font-size: 16px;
            border: none;
            outline: none;
            caret-color: #1f2129;
          }
          .focus-input .input textarea::-moz-placeholder {
            color: #979aa8;
          }
          .focus-input .input textarea::-webkit-input-placeholder {
            color: #979aa8;
          }
          .focus-input .input textarea:-ms-input-placeholder {
            color: #979aa8;
          }

          .focus-input .submit {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 108px;
            height: 48px;
            background-color: #1a1a1a;
            color: white;
            font-size: 16px;
            cursor: pointer;
            align-self: flex-end;
          }
        `}
      </style>
    </div>
  )
}

export default Input
